import { useFluentContext } from '@fluentui/react-bindings';
import * as PropTypes from 'prop-types';
import * as React from 'react';
/**
 * A ProviderConsumer is used to consume Fluent UI context from Provider.
 */
export var ProviderConsumer = /*#__PURE__*/function () {
  var ProviderConsumer = function ProviderConsumer(props) {
    var render = props.render;
    var context = useFluentContext();
    return /*#__PURE__*/React.createElement(React.Fragment, null, render(context.theme));
  };
  ProviderConsumer.displayName = 'ProviderConsumer';
  ProviderConsumer.propTypes = {
    render: PropTypes.func.isRequired
  };
  return ProviderConsumer;
}();
//# sourceMappingURL=ProviderConsumer.js.map
